import { api } from "@/api/client";
import type { AuthResponse, LoginRequest, LogoutRequest, RefreshRequest, RegisterRequest } from "@/api/types";

export const login = (payload: LoginRequest) => api.post<AuthResponse>("/v1/auth/login", payload);
export const register = (payload: RegisterRequest) => api.post<AuthResponse>("/v1/auth/register", payload);
export const refresh = (payload: RefreshRequest) => api.post<AuthResponse>("/v1/auth/refresh", payload);
export const logout = (payload: LogoutRequest) => api.post<void>("/v1/auth/logout", payload);
